var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert(".modal-touch{position:fixed;top:0;left:0;width:100%;height:100%;z-index:99999;background-color:#fff;box-sizing:border-box;padding:60px 45px;text-align:center;overflow-y:auto}.modal-touch .modal-touch-close{position:absolute;top:17px;right:17px;color:var(--color-gray-md)}.modal-touch .modal-touch-close:active,.modal-touch .modal-touch-close:focus,.modal-touch .modal-touch-close:hover{color:var(--color-gray-dk)}.modal-touch .modal-title{font-size:20px;letter-spacing:1px;font-weight:700;padding-bottom:12px}")
;(function(){var EVENTS, EVENT_PREFIX, MODAL_IDS, OPEN_MODAL_ID, SLS_HEADER_SELECTOR, VALIDATOR;

SLS_HEADER_SELECTOR = '.t-header-wrapper-v2, #ls-header, .ls-header';

EVENT_PREFIX = 'modal-touch-';

EVENTS = {
  OPEN: EVENT_PREFIX + "open",
  OPENED: EVENT_PREFIX + "opened",
  CLOSE: EVENT_PREFIX + "close",
  CLOSED: EVENT_PREFIX + "closed"
};

OPEN_MODAL_ID = null;

MODAL_IDS = [];

VALIDATOR = function(id) {
  return id && (MODAL_IDS.indexOf(id) < 0);
};

module.exports = {
  data: function() {
    return {
      open: false,
      valid: false
    };
  },
  props: {
    id: {
      type: String,
      required: true,
      validator: VALIDATOR
    }
  },
  watch: {
    open: function(value) {
      if (value) {
        $(SLS_HEADER_SELECTOR).hide();
        if (OPEN_MODAL_ID && (OPEN_MODAL_ID !== this.id)) {
          this.$events.emit(EVENTS.CLOSE, OPEN_MODAL_ID);
        }
        OPEN_MODAL_ID = this.id;
        return this.$events.emit(EVENTS.OPENED, this.id);
      } else {
        $(SLS_HEADER_SELECTOR).show();
        if (OPEN_MODAL_ID === this.id) {
          OPEN_MODAL_ID = null;
        }
        return this.$events.emit(EVENTS.CLOSED, this.id);
      }
    }
  },
  methods: {
    close: function() {
      return this.$events.emit(EVENTS.CLOSE, this.id);
    }
  },
  created: function() {
    if (VALIDATOR(this.id)) {
      MODAL_IDS.push(this.id);
      return this.valid = true;
    }
  },
  mounted: function() {
    if (this.valid) {
      this.$events.on(EVENTS.OPEN, (function(_this) {
        return function(id) {
          if (id === _this.id) {
            return _this.open = true;
          }
        };
      })(this));
      return this.$events.on(EVENTS.CLOSE, (function(_this) {
        return function(id) {
          if (id === _this.id) {
            return _this.open = false;
          }
        };
      })(this));
    }
  },
  beforeDestroy: function() {
    MODAL_IDS.splice(MODAL_IDS.indexOf(this.id), 1);
    this.$events.off(EVENTS.OPEN);
    return this.$events.off(EVENTS.CLOSE);
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function(){with(this){return (valid && open)?_c('div',{staticClass:"modal-touch"},[_t("default"),_v(" "),_c('span',{staticClass:"modal-touch-close icon icon-x",on:{"click":close}})],2):_e()}}
__vue__options__.staticRenderFns = []
